import { activityNames, activityTypes } from '../../../utils/constants/misc'
import {
  dateOperators,
  equalityOperators,
  multiselectOperators,
  textOperators
} from '../../../utils/constants/operators'

export const priceBookColumns = [
  {
    name: 'description',
    label: 'Description',
    isFilter: true,
    operators: textOperators
  },
  {
    name: 'quantity',
    label: 'Quantité',
    type: 'float'
  },
  {
    name: 'unit_price',
    label: 'Prix unitaire',
    type: 'currency'
  },
  {
    name: 'item_type',
    label: 'Categorie',
    isFilter: true,
    valueEditorType: 'multiselect',
    values: activityNames,
    operators: [...equalityOperators, ...multiselectOperators],
    mapping: (id) => {
      const result = activityNames.find((item) => item.id === id)
      return result ? result.label : id
    }
  },
  {
    name: 'type',
    label: 'Type',
    mapping: (id) => {
      const result = activityTypes.find((item) => item.id === id)
      return result ? result.label : id
    },
    isFilter: true,
    valueEditorType: 'multiselect',
    values: activityTypes,
    operators: [...equalityOperators, ...multiselectOperators]
  },
  {
    name: 'createdDateTime',
    label: 'Date Création',
    isFilter: true,
    inputType: 'datetime-local',
    type: 'date',
    format: 'DD/MM/YYYY HH:mm:ss',
    operators: dateOperators
  },
  {
    name: 'createdBy',
    label: 'Créé Par',
    isFilter: true,
    operators: textOperators
  },
  {
    name: 'lastModDateTime',
    label: 'Date Modification',
    isFilter: true,
    inputType: 'datetime-local',
    type: 'date',
    format: 'DD/MM/YYYY HH:mm:ss',
    operators: dateOperators
  },
  {
    name: 'lastModBy',
    label: 'Modifié Par',
    isFilter: true,
    operators: textOperators
  }
]

export const getPriceBookFields = () => [
  [
    {
      name: 'description',
      label: 'Description',
      required: true,
      type: 'text',
      fullWidth: true,
      validation: [
        {
          rule: 'req',
          error: 'Description obligatoire'
        }
      ]
    }
  ],
  [
    {
      name: 'quantity',
      label: 'Quantité',
      required: true,
      fullWidth: true,
      type: 'float',
      min: 0,
      validation: [
        {
          rule: 'req',
          error: 'Quantité obligatoire'
        }
      ]
    }
  ],
  [
    {
      name: 'unit_price',
      label: 'Prix unitaire',
      type: 'currency',
      fullWidth: true,
      validation: [
        {
          rule: 'req',
          error: 'Prix unitaire obligatoire'
        }
      ]
    }
  ],

  [
    {
      name: 'item_type',
      label: 'Catégorie',
      type: 'select',
      required: true,
      options: {
        type: 'data',
        returnField: 'id',
        returnFields: ['id'],
        value: 'name',
        data: [
          {
            id: 1,
            name: "Main d'oeuvre"
          },
          {
            id: 2,
            name: 'Déplacement'
          },
          {
            id: 3,
            name: 'Matériel'
          }
        ]
      },
      fullWidth: true,
      validation: [
        {
          rule: 'req',
          error: 'Catégorie obligatoire'
        }
      ]
    }
  ],
  [
    {
      name: 'type',
      label: 'Type',
      type: 'select',
      required: true,
      options: {
        type: 'data',
        returnField: 'id',
        returnFields: ['id'],
        value: 'name',
        data: [
          {
            id: 1,
            name: 'Vente marchandise'
          },
          {
            id: 2,
            name: 'Prestation services commerciales/artisanales'
          },
          {
            id: 3,
            name: 'Prestation services et activités libérales'
          }
        ]
      },
      fullWidth: true,
      validation: [
        {
          rule: 'req',
          error: 'Catégorie obligatoire'
        }
      ]
    }
  ]
]
